import { ATTRIBUTE_CLIENT_ID, ATTRIBUTE_CLIENT_SCOPES, ATTRIBUTE_DEPLOY_HUB_CODE, ATTRIBUTE_DEPLOY_HUB_ID, ATTRIBUTE_USER_COUNTRY, ATTRIBUTE_USER_ID, ATTRIBUTE_USER_ORG_ID, ATTRIBUTE_USER_ORG_ROLE, ATTRIBUTE_USER_ULT_SITE, } from '@local/metrics/dist/src/metrics.constants';
import { decodeToken, isExpired } from 'react-jwt';
import { bentleyIssuers, COMBINED_TOKEN_KEY, seequentIssuers } from '../../../constants';
import { getCurrentEvoInstance } from '../entitlementsHelper/entitlementsHelper';
export const AUTH_CODE_KEY = 'authCode';
export const DEFAULT_EXPIRY = 24 * 60 * 60 - 1;
export function setCombinedToken(accessTokenResponse) {
    const accessToken = Object.assign(Object.assign({}, accessTokenResponse), { expires_at: Date.now() + (accessTokenResponse.expires_in || DEFAULT_EXPIRY) * 1000 });
    localStorage.setItem(COMBINED_TOKEN_KEY, JSON.stringify(accessToken));
}
export function getCombinedToken() {
    try {
        return JSON.parse(localStorage.getItem(COMBINED_TOKEN_KEY) || '{}');
    }
    catch (_a) {
        return null;
    }
}
export function isTokenExpired() {
    const token = getCombinedToken();
    if (!(token === null || token === void 0 ? void 0 : token.access_token)) {
        return false;
    }
    return isExpired(token.access_token);
}
export function isLoggedInWithBentleyToken() {
    var _a;
    const combinedToken = getCombinedToken();
    const idTokenDecoded = decodeToken((_a = combinedToken === null || combinedToken === void 0 ? void 0 : combinedToken.id_token) !== null && _a !== void 0 ? _a : '');
    const issuer = idTokenDecoded === null || idTokenDecoded === void 0 ? void 0 : idTokenDecoded.iss;
    if (issuer === undefined) {
        return undefined;
    }
    try {
        const issuerHostname = new URL(issuer).hostname;
        if (seequentIssuers.includes(issuerHostname)) {
            return false;
        }
        if (bentleyIssuers.includes(issuerHostname)) {
            return true;
        }
    }
    catch (_b) {
        return undefined;
    }
    return undefined;
}
export function getDecodedBentleyAccessToken() {
    const combinedToken = getCombinedToken();
    if (combinedToken === null || combinedToken === void 0 ? void 0 : combinedToken.access_token) {
        return decodeToken(combinedToken.access_token);
    }
    return null;
}
export function clearCombinedToken() {
    localStorage.removeItem(COMBINED_TOKEN_KEY);
    sessionStorage.removeItem(AUTH_CODE_KEY);
}
export function getUserContext() {
    var _a;
    const accessToken = (_a = getCombinedToken()) === null || _a === void 0 ? void 0 : _a.access_token;
    const decodedToken = accessToken ? decodeToken(accessToken) : null;
    const { org, hub } = getCurrentEvoInstance();
    const attributes = {};
    if (decodedToken !== null) {
        const { role } = decodedToken;
        const distinctRole = new Set(role);
        const loggedRole = typeof role === 'string' ? role : Array.from(distinctRole).join(' ');
        Object.assign(attributes, {
            [ATTRIBUTE_USER_ID]: decodedToken.sub,
            [ATTRIBUTE_USER_ULT_SITE]: decodedToken.ultimate_site,
            [ATTRIBUTE_USER_ORG_ID]: decodedToken.org,
            [ATTRIBUTE_CLIENT_ID]: decodedToken.client_id,
            [ATTRIBUTE_CLIENT_SCOPES]: decodedToken.scope.join(' '),
            [ATTRIBUTE_USER_ORG_ROLE]: loggedRole,
            [ATTRIBUTE_USER_COUNTRY]: decodedToken.usage_country_iso,
        });
    }
    if (hub === null || hub === void 0 ? void 0 : hub.code) {
        Object.assign(attributes, {
            [ATTRIBUTE_DEPLOY_HUB_CODE]: hub.code,
            [ATTRIBUTE_DEPLOY_HUB_ID]: hub.display_name,
        });
    }
    if (org === null || org === void 0 ? void 0 : org.id) {
        Object.assign(attributes, {
            [ATTRIBUTE_USER_ORG_ID]: org.id,
        });
    }
    return attributes;
}
//# sourceMappingURL=accessTokenHelper.js.map